"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressEvent;
var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
/**
 * Object of the same shape as web browser ProgressEvents
 * @class ProgressEvent
 * @param {integer} loaded
 * @param {integer} total
 * @returns {ProgressEvent}
 */
function ProgressEvent(loaded, total) {
  (0, _defineProperties.default)(this, {
    loaded: {
      enumerable: true,
      value: loaded,
      writable: false
    },
    total: {
      enumerable: true,
      value: total,
      writable: false
    },
    lengthComputable: {
      enumerable: true,
      value: (0, _isNumber2.default)(loaded) && !(0, _isNan.default)(loaded) && (0, _isNumber2.default)(total) && !(0, _isNan.default)(total) && total > 0,
      writable: false
    }
  });
}
//# sourceMappingURL=progress-event.js.map
